import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import LegalModal from '../../../components/ui/LegalModal';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);

  const quickLinks = [
    { name: 'Services', href: '#services' },
    // { name: 'Preise', href: '#pricing' },
    { name: 'Standorte', href: '#locations' },
    // { name: 'Galerie', href: '#gallery' },
    { name: 'Kontakt', href: '#contact' },
    { name: 'Beschwerden', href: '#contact' }
  ];

  const services = {
    left: [
      'Tango Wachs',
      'Außenhandwäsche',
      'Innenreinigung + Außenhandwäsche',
      'Lederpflege',
      'Nanoversiegelung',
      'Keramikversiegelung',
      'Polsterreinigung'
    ],
    right: [
      'Himmelreinigung',
      'Motor Wache',
      'Innen Komplet + Außenhandwäsche',
      'Innen Komplet',
      'Polieren',
      'Lackaufbereitung',
      'Komplettaufbereitung',
      'Innenreinigung'
    ]
  };

  const legalLinks = [
    { name: 'Impressum', action: () => setIsLegalModalOpen(true) },
    { name: 'Datenschutz', action: () => setIsLegalModalOpen(true) },
    { name: 'AGB', action: () => setIsLegalModalOpen(true) },
    { name: 'Widerrufsrecht', action: () => setIsLegalModalOpen(true) }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId?.replace('#', ''));
    if (element) {
      const headerHeight = 80;
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-black to-primary text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white rounded-lg flex items-center justify-center p-1">
                <img 
                  src="/assets/images/Ragnalogo.jpg" 
                  alt="RAGNA Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-base md:text-lg font-bold">Ragna Detailing</h3>
              </div>
            </div>
            <p className="text-white/80 mb-4 leading-relaxed text-xs md:text-sm">
              Seit über 15 Jahren Ihr Partner für professionelle Autopflege in Dinslaken. 
              Qualität, Zuverlässigkeit und Leidenschaft für Perfektion.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-2 md:space-x-3">
              <a
                href="https://facebook.com/ragna_detailing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 md:w-8 md:h-8 bg-white/10 rounded-lg flex items-center justify-center hover:bg-accent transition-colors"
                aria-label="Facebook"
              >
                <Icon name="Facebook" size={14} />
              </a>
              <a
                href="https://instagram.com/ragna_detailing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 md:w-8 md:h-8 bg-white/10 rounded-lg flex items-center justify-center hover:bg-accent transition-colors"
                aria-label="Instagram"
              >
                <Icon name="Instagram" size={14} />
              </a>
              <a
                href="https://wa.me/491636923382"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 md:w-8 md:h-8 bg-white/10 rounded-lg flex items-center justify-center hover:bg-success transition-colors"
                aria-label="WhatsApp"
              >
                <Icon name="MessageCircle" size={14} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4">Navigation</h4>
            <ul className="space-y-1 md:space-y-2">
              {quickLinks?.map((link) => (
                <li key={link?.name}>
                  <button
                    onClick={() => scrollToSection(link?.href)}
                    className="text-white/80 hover:text-accent transition-colors text-xs md:text-sm"
                  >
                    {link?.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4">Unsere Services</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1 md:gap-y-2">
              {/* Left Column */}
              <ul className="space-y-1 md:space-y-2">
                {services?.left?.map((service) => (
                  <li key={service}>
                    <span className="text-white/80 text-xs md:text-sm">{service}</span>
                  </li>
                ))}
              </ul>
              {/* Right Column */}
              <ul className="space-y-1 md:space-y-2">
                {services?.right?.map((service) => (
                  <li key={service}>
                    <span className="text-white/80 text-xs md:text-sm">{service}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm md:text-base font-semibold mb-3 md:mb-4">Kontakt</h4>
            
            {/* Dinslaken - Hauptsitz */}
            <div className="mb-3 md:mb-4">
              <h5 className="font-medium text-accent mb-2 text-xs md:text-sm">Dinslaken (Hauptsitz)</h5>
              <div className="space-y-1 text-xs text-white/80">
                <div className="flex items-start space-x-2">
                  <Icon name="MapPin" size={10} className="mt-0.5" />
                  <span> Otto-Lilienthal-Straße 43, 46539 Dinslaken</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={10} />
                  <a href="tel:02064 777722" className="hover:text-accent transition-colors">
                    02064 777722
                  </a>
                </div>
                <div className="flex items-start space-x-2">
                  <Icon name="Mail" size={10} className="mt-0.5" />
                  <a href="mailto:ragnadetailing@gmail.com" className="hover:text-accent transition-colors break-all">
                    ragnadetailing@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Dinslaken - Zweigstelle */}
            <div className="mb-3 md:mb-4">
              <h5 className="font-medium text-accent mb-2 text-xs md:text-sm">Dinslaken (Zweigstelle)</h5>
              <div className="space-y-1 text-xs text-white/80">
                <div className="flex items-start space-x-2">
                  <Icon name="MapPin" size={10} className="mt-0.5" />
                  <span> Hünxer Straße 131, 46539 Dinslaken</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={10} />
                  <a href="tel:02064 777722" className="hover:text-accent transition-colors">
                    02064 777722
                  </a>
                </div>
                <div className="flex items-start space-x-2">
                  <Icon name="Mail" size={10} className="mt-0.5" />
                  <a href="mailto:ragnadetailing@gmail.com" className="hover:text-accent transition-colors break-all">
                    ragnadetailing@gmail.com
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Business Hours */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 md:py-5">
          <div className="text-center">
            <h4 className="font-semibold mb-3 flex items-center justify-center space-x-2 text-xs md:text-sm">
              <Icon name="Clock" size={12} />
              <span>Öffnungszeiten</span>
            </h4>
            <div className="space-y-1 text-xs text-white/80 max-w-md mx-auto">
              <div className="flex justify-between">
                <span>Montag - Freitag:</span>
                <span>08:00 - 17:30 Uhr</span>
              </div>
              <div className="flex justify-between">
                <span>Samstag:</span>
                <span>08:00 - 16:00 Uhr</span>
              </div>
              <div className="flex justify-between">
                <span>Sonntag:</span>
                <span>Geschlossen</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Footer */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
            <div className="text-xs text-white/80 text-center md:text-left">
              © {currentYear} Ragna Detailing. Alle Rechte vorbehalten.
            </div>
            
            <div className="flex flex-wrap items-center justify-center space-x-3 md:space-x-4">
              {legalLinks?.map((link) => (
                <button
                  key={link?.name}
                  onClick={link?.action}
                  className="text-xs text-white/80 hover:text-accent transition-colors"
                >
                  {link?.name}
                </button>
              ))}
            </div>
          </div>
          
          <div className="mt-3 pt-3 border-t border-white/10 text-center">
            <div className="text-xs text-white/60">
              <p className="mb-1">
                <strong>Geschäftsführer:</strong> Amjad & Ahmad
              </p>
              <p>
                Ragna Detailing
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Legal Modal */}
      <LegalModal 
        isOpen={isLegalModalOpen} 
        onClose={() => setIsLegalModalOpen(false)} 
      />
    </footer>
  );
};

export default Footer;